import { List, Tabs } from 'antd';
import React from 'react';

const VideoTopics = ({ chapterTopics }) => {
  return (
    <>
      {chapterTopics.map((item, index) => (
        <div key={index} className="flex items-start justify-between w-full my-2 py-4 px-4 border-b">
          <p className="mb-0 min-w-[200px] max-w-[150px]">{item.topicName}</p>
          {item.topicVideo && item.topicVideo.videoURL ? (
            <video
              className="min-w-[200px] pr-2"
              controls
              type="video/mp4"
              width={300}
              height={300}
              src={item.topicVideo.videoURL}
            />
          ) : (
            <div className="flex items-center justify-center text-xs min-w-[200px]">No video available</div>
          )}
        </div>
      ))}
      {/* <List
        header={<p className="mb-0">List of topics</p>}
        className="mt-0 pt-0 mx-0 px-0"
        itemLayout="horizontal"
        bordered
        dataSource={chapterTopics}
        renderItem={(item, index) => (
          <List.Item className="flex items-start justify-center my-0 px-0 mx-0 ">
            <List.Item.Meta title={<p className="mb-0">{item.topicName}</p>} />
            <List.Item.Meta
              title={
                item.topicVideo && item.topicVideo.videoURL ? (
                  <video
                    className=""
                    controls
                    type="video/mp4"
                    width={300}
                    height={300}
                    src={item.topicVideo.videoURL}
                  />
                ) : (
                  <div className="flex items-center justify-center text-xs">No video available</div>
                )
              }
            />
          </List.Item>
        )}
      /> */}
    </>
  );
};

export default VideoTopics;
